import React from 'react';

require('bulma/css/bulma.css');
require('font-awesome/css/font-awesome.min.css');
require('./main.css');

export default class EmptyLayout extends React.Component {
  render() {
    return (
      <div>
        <section className="section">{this.props.children}</section>
      </div>
    );
  }
}
